/**
 * Süperadmin merchant yardımcıları — list + detail sayfalarının paylaştığı
 * saf formatlayıcılar (plan rozeti, sağlık rengi, göreli zaman).
 */

export const PLAN_META = {
    trial:    { label: "Deneme",   tone: "bg-amber-100 text-amber-900 border-amber-300",   dot: "bg-amber-500" },
    monthly:  { label: "Aylık",    tone: "bg-sky-100 text-sky-900 border-sky-300",         dot: "bg-sky-500" },
    yearly:   { label: "Yıllık",   tone: "bg-emerald-100 text-emerald-900 border-emerald-300", dot: "bg-emerald-500" },
    two_year: { label: "2 Yıllık", tone: "bg-violet-100 text-violet-900 border-violet-300", dot: "bg-violet-500" },
    sayz:     { label: "Aktif",    tone: "bg-emerald-100 text-emerald-900 border-emerald-300", dot: "bg-emerald-500" },
};

export const HEALTH_META = {
    green:  { label: "Sağlıklı", dot: "bg-emerald-500", ring: "ring-emerald-500/30" },
    yellow: { label: "Dikkat",   dot: "bg-amber-500",   ring: "ring-amber-500/30" },
    red:    { label: "Kritik",   dot: "bg-rose-500",    ring: "ring-rose-500/30" },
};

/** TRY formatter — 20000 → "₺20.000". */
export function formatTRY(n) {
    if (n == null) return "—";
    try {
        return new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n);
    } catch {
        return `₺${n}`;
    }
}

/** Türkiye KDV oranı — hizmet standart %20 (2026). */
export const KDV_RATE = 0.20;

/**
 * Plan fiyatlarını hesapla.
 * `price_try` KDV HARİÇ liste fiyatı. İndirim varsa indirim UYGULANMIŞ hali
 * backend'de "price_try" olarak gelmez — hem list hem final göstermek için
 * discount_pct ile tersten hesaplıyoruz.
 *
 * Dönen alanlar:
 *   - listExVAT     Liste fiyatı, KDV hariç (indirim öncesi)
 *   - listInclVAT   Liste fiyatı, KDV dahil
 *   - finalExVAT    İndirim sonrası, KDV hariç
 *   - finalInclVAT  İndirim sonrası, KDV dahil
 *   - hasDiscount   discount_pct > 0
 *   - discountPct   indirim yüzdesi (0–100)
 */
export function computePlanPrices(plan) {
    const base = Number(plan?.price_try || 0);
    const discountPct = Number(plan?.discount_pct || 0);
    const listExVAT = base;
    const listInclVAT = Math.round(base * (1 + KDV_RATE));
    const finalExVAT = discountPct > 0 ? Math.round(base * (1 - discountPct / 100)) : base;
    const finalInclVAT = Math.round(finalExVAT * (1 + KDV_RATE));
    return {
        listExVAT,
        listInclVAT,
        finalExVAT,
        finalInclVAT,
        hasDiscount: discountPct > 0,
        discountPct,
    };
}

/** Relative time — ISO → "3 saat önce" / "2 gün önce". null → "—". */
export function relTime(iso, now = Date.now()) {
    if (!iso) return "—";
    const t = typeof iso === "number" ? iso : Date.parse(iso);
    if (!t) return "—";
    const diff = Math.floor((now - t) / 1000);
    if (diff < 60) return "az önce";
    if (diff < 3600) return `${Math.floor(diff / 60)} dk önce`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} saat önce`;
    const days = Math.floor(diff / 86400);
    if (days < 30) return `${days} gün önce`;
    if (days < 365) return `${Math.floor(days / 30)} ay önce`;
    return `${Math.floor(days / 365)} yıl önce`;
}

/** Short date — ISO → "19 Eki 2026". */
export function fmtDate(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" });
}

/** Full date-time — ISO → "19 Eki 2026 · 14:30". */
export function fmtDateTime(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "—";
    return (
        d.toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" }) +
        " · " +
        d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })
    );
}

/** Hata metnini standartlaştır. */
export function readError(err) {
    const d = err?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" · ");
    return err?.message || "İşlem başarısız";
}
